import { render, staticRenderFns } from "./pricehelp.vue?vue&type=template&id=20b73ccd&"
import script from "./pricehelp.vue?vue&type=script&lang=js&"
export * from "./pricehelp.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('20b73ccd')) {
      api.createRecord('20b73ccd', component.options)
    } else {
      api.reload('20b73ccd', component.options)
    }
    module.hot.accept("./pricehelp.vue?vue&type=template&id=20b73ccd&", function () {
      api.rerender('20b73ccd', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-26MWb6Cu2sH5d/JS/pricehelp.vue"
export default component.exports